'use client';

import { getDefaultVariantsFromProducts, getFirstVariant } from 'ui';
import { RadioSwatchesV2 } from 'ui/components/RadioSwatchesV2/RadioSwatchesV2';
import Eyebrow from '../../Eyebrow/Eyebrow';
import type { Language } from '@whoop/i18n';
import type { Product } from 'services/generated/commerce-service/models/Product';
import type { Variant } from 'services/generated/commerce-service/models/Variant';
import { useTranslation } from '@whoop/i18n/lang/client';

interface IDefaultBandSelectorProps {
  language: Language;
  onSwatchClick: (variant: Variant) => void;
  onSwatchHover: (variant?: Variant) => void;
  isMobile?: boolean;
  swatchProducts: Product[];
  selectedVariant: Variant;
  showEngravingModal: boolean;
  variantLabel: () => JSX.Element | null;
}

const DefaultBandSelector: React.FC<IDefaultBandSelectorProps> = ({
  onSwatchClick,
  onSwatchHover,
  isMobile,
  swatchProducts,
  selectedVariant,
  variantLabel,
}) => {
  const { t } = useTranslation('joinLandingPage');
  return (
    <>
      <div>
        <h2 className='py-4 text-left text-xl font-bold md:pt-0 md:text-3xl'>
          {t('chooseWhoop4Band')}
        </h2>
        {variantLabel()}
        <Eyebrow />
      </div>
      <div className='z-20 flex flex-col gap-1 py-3 md:pt-6'>
        <RadioSwatchesV2
          allowDeselect
          defaultSelection={getFirstVariant(swatchProducts[0])}
          onClick={onSwatchClick}
          onHover={onSwatchHover}
          selectedSwatch={selectedVariant}
          showCheckmark
          swatchSize={isMobile ? 'medium' : 'large'}
          swatchType='color'
          variants={getDefaultVariantsFromProducts(swatchProducts)}
        />
      </div>
    </>
  );
};
export default DefaultBandSelector;
